import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import type { WorkEnvironmentEvaluation } from '../../../api/workEnvironmentTypes';
import { monthAndYear } from '../evaluationView';
import process from '../WorkEnvironmentSurveyProcess.module.css';

type Props = {
  baseline: WorkEnvironmentEvaluation['baseline'];
};

export const PreviousCard = ({ baseline }: Props): ReactElement => {
  const { t, i18n } = useTranslation();
  return (
    <section
      aria-labelledby="evaluation-previous-heading"
      className={`${process.card} ${process.sideCard}`}
    >
      <Heading level={2} data-size="xs" id="evaluation-previous-heading">
        {t('workEnvironmentEvaluation.previous.title')}
      </Heading>
      <Paragraph data-size="sm">
        {t('workEnvironmentEvaluation.previous.text', {
          high: baseline.highRisk,
          count: baseline.areas,
          month: monthAndYear(baseline.createdAt, i18n.language),
        })}
      </Paragraph>
    </section>
  );
};
